import { combineReducers } from 'redux'
import { contentReducer } from './contentReducer'
import { searchTableReducer } from './searchTableReducer'
import { commonReducer } from './commonReducer'
import { sweetAlertReducer } from './sweetAlertReducer'

const initialState = {
  sidebarShow: true,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const rootReducer = combineReducers({
  nav: changeState,
  contentReducer,
  commonReducer,
  searchTableReducer,
  sweetAlertReducer,
})

export default rootReducer
